import { createAction, props } from "@ngrx/store";
import {
  RoomStageLayoutDeferredErrorVO,
  RoomStageLayoutStreamsSetEventVO
} from "@youm-front/room/domain";

export const roomStageLayoutStreamsSetEvent = createAction(
  "[Room] Room Stage Layout Streams Set Event",
  props<{
    roomStageLayoutStreamsSetEventVO: RoomStageLayoutStreamsSetEventVO;
  }>()
);

export const roomStageLayoutDeferredErrorEvent = createAction(
  "[Room] Room Stage Layout Deferred Error Event",
  props<{
    roomStageLayoutDeferredErrorVO: RoomStageLayoutDeferredErrorVO;
  }>()
);
